import * as React from 'react';

import * as Sentry from '@sentry/react';
import * as ReactDOM from 'react-dom';

import { App } from '../../App';

window.__hash__ = process.env.APP_VERSION;

try {
  Sentry.init({
    // From https://atlassian-2y.sentry.io/settings/projects/bifrost-cookies-ui/keys/
    dsn: 'https://630bbbf19730eb8559519d4b11f1364e@o55978.ingest.us.sentry.io/4507304393048064',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    release: process.env.APP_VERSION ?? 'unknown',
  });
} catch (e) {
  console.error(e);
}

const mountNode = document.getElementById('app');
ReactDOM.render(<App />, mountNode);
